// Modules
import { Store } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import { SignalRService } from './general/services/signalr/signalr.service';

// Services
import { AppConfigService } from '@shared-module/services/app-config/app-config.service';

// Store - Reducer
import { AppState } from '@store/reducers';
// Store - Actions
import * as AuthActions from '@store/actions/auth.actions';

@Component({
    selector: 'sbi-cot-back-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements OnInit {
  // Constructor
  // Added comment : *
  constructor(
    private _app: AppConfigService,
    private signalRService: SignalRService,
    private _store: Store<AppState>
  ) {}

  // On component init
  ngOnInit() {
    this._checkForLoggedUser();
    this.signalRService.startConnection();
  }

  // Private method to check for a logged user
  private _checkForLoggedUser(): void {
    const loggedUser = JSON.parse(
      sessionStorage.getItem(this._app.loggedUserSessionKey)
    );
    this._store.dispatch(
      AuthActions.checkForLoggedUser({ payload: loggedUser || null })
    );
  }
}
/* Run pipes */
